<template>
  <div>
    <div class="container">
      <div class="search">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="兑换码">
            <el-input placeholder="请输入兑换码" v-model="code"></el-input>
          </el-form-item>
          <el-form-item label="用户电话">
            <el-select
              v-model="selected_user"
              placeholder="请输入用户电话"
              value-key="user_id"
              filterable
              remote
              :remote-method="getUser"
              clearable
            >
              <el-option
                v-for="item in userList"
                :key="item.user_id"
                :label="item.nick_name"
                :value="item.user_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit()">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="openEx()">兑换</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div>
        <div class="contentList">
          <div class="paging">
            <el-table
              ref="multipleTable"
              :header-cell-style="{ background: '#EAEAEA', color: '#434343' }"
              :data="tableData"
              style="width: 100%"
              @filter-change="filterChange"
            >
              <el-table-column
                prop="id"
                align="center"
                label="id"
              ></el-table-column>

              <el-table-column
                :formatter="fromTitle"
                prop="map.getUserInfo.nick_name"
                align="center"
                label="发放用户"
              ></el-table-column>
              <el-table-column
                :formatter="fromTitle"
                prop="map.getUserInfo.mobile"
                align="center"
                label="手机号"
              ></el-table-column>
              <!-- <el-table-column prop="start_num" align="center"  label="卡号"></el-table-column> -->
              <el-table-column
                prop="coupon_code"
                align="center"
                label="兑换码"
              ></el-table-column>
              <el-table-column prop="type" align="center" label="卡类型">
                <template slot-scope="scope">
                  {{
                    scope.row.coupon_type == "尊享卡"
                      ? scope.row.is_pay
                        ? "尊享卡"
                        : "特殊尊享卡"
                      : scope.row.coupon_type
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="status" align="center" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 1">已领取</span>
                  <span v-if="scope.row.status == 2">未领取</span>
                  <span v-if="scope.row.status == 4">过期</span>
                  <span v-if="scope.row.status == 5">未启用</span>
                  <span v-if="scope.row.status == 6">失效</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="create_time"
                align="center"
                width="200"
                label="发放时间"
              ></el-table-column>
              <el-table-column
                prop="overdue_time"
                align="center"
                width="200"
                label="过期时间"
              ></el-table-column>
              <el-table-column prop="" align="center" width="200" label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    v-if="scope.row.status == 5"
                    @click="openit(scope.row, { status: 2 })"
                    >启用
                  </el-button>
                  <el-button
                    size="small"
                    v-if="scope.row.status == 2"
                    @click="openit(scope.row, { status: 5 })"
                    >关闭
                  </el-button>
                  <el-button
                    size="small"
                    v-if="
                      scope.row.coupon_type == '尊享卡' &&
                      scope.row.is_pay == true &&
                      (scope.row.status == 2 || scope.row.status == 5)
                    "
                    @click="openit(scope.row, { is_pay: false })"
                    >切换特殊尊享卡</el-button
                  >
                  <el-button
                    size="small"
                    v-if="
                      scope.row.coupon_type == '尊享卡' &&
                      scope.row.is_pay == false &&
                      (scope.row.status == 2 || scope.row.status == 5)
                    "
                    @click="openit(scope.row, { is_pay: true })"
                    >切换尊享卡</el-button
                  >
                  <el-button
                    size="small"
                    v-if="scope.row.status == 5 || scope.row.status == 2"
                    type="danger"
                    @click="openit(scope.row, 6)"
                    >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!--分页-->
            <paging-fy
              @currentPageChange="handleCurrentChange"
              :currentPage="currentPage"
              :total="total"
            ></paging-fy>
          </div>
        </div>
        <input
          id="copy_content"
          type="text"
          value=""
          style="position: absolute; top: 0; left: 0; opacity: 0; z-index: -10"
        />
      </div>
    </div>

    <el-dialog title="兑换" :visible.sync="Visible" width="30%">
      <el-form class="demo-form-inline" label-width="70px">
        <el-form-item label="用户">
          <userSelect :userid.sync="user_id"></userSelect>
        </el-form-item>
        <el-form-item label="兑换码">
          <el-input v-model="EXcode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="userExCode">兑换</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
  
  <script>
import userSelect from "@/components/select/userSelect.vue";
export default {
  name: "LiveStreaming",
  components: { userSelect },
  data() {
    return {
      nav: {
        firstNav: "兑换码管理",
        secondNav: "领取记录管理",
      },
      tableData: [], //总数据
      stateCode: "",
      Visible: false,
      name: "",
      phone: "",
      couponCode: "",
      index: 1,
      form: {
        user: "",
        date1: "",
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
      code: "",
      EXcode: "",
      selected_user: "",
      userList: [],
      user_id: "",
    };
  },
  mounted() {
    // this.GetNumbers();
    this.GetList();
  },
  methods: {
    
    openEx() {
      this.Visible = true;
    },
    //兑换
    userExCode() {
      console.log('999');
      let url = "/user/couponList/useDiscountVolume1";
      this.$axios({
        url,
        data: {
          get_code_user_id: this.user_id,
          coupon_code: this.EXcode,
        },
        method: "post",
      }).then((res) => {
        if (res.data.code == 0) {
          this.Visible = false;
          this.$message({ message: "兑换成功" });
          this.GetList();
        }else{
          this.$message({ message: res.data.message });
        }
      });
    },
    getUser(query) {
      this.user_list = [];
      if (query && typeof query == "string") {
        let url = "/user/user/queryByMessage";
        this.$axios
          .get(url, {
            params: {
              login_name: query,
            },
          })
          .then((res) => {
            this.userList = res.data.data.rows;
          });
      }
    },
    fromTitle(row, column, cellValue) {
      if (cellValue === "" || cellValue == null) {
        return "暂无";
      } else {
        return cellValue;
      }
    },
    openit(row) {
      let url = "/user/couponList/update";
      this.$axios
        .post(url, {
          id: row.id,
          status: 2,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "成功!",
            });
            this.GetList();
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        });
    },
    changeIndex(v) {
      this.index = v;
      switch (this.index) {
      }
    },
    filterChange(filterObj) {
      //  console.log(filterObj, "当列数据");
    },
    GetList() {
      let data = {
        currentPage: this.currentPage,
      };
      if (this.code != "") {
        data.coupon_code = this.code;
      }
      if (this.selected_user != "") {
        data.get_code_user_id = this.selected_user;
      }

      this.$axios
        .get("/user/couponList/queryManagerListPage", { params: data })
        .then((res) => {
          this.tableData = res.data.data.rows;
          this.total = res.data.data.total;
          this.tableData.forEach((e) => {
            if (e.create_time > e.overdue_time) {
              this.stateCode = "已过期";
              e.stateS = this.stateCode;
            } else {
              this.stateCode = "已使用";
              e.stateS = this.stateCode;
            }
          });
        });
    },
    handleCurrentChange(val) {
      //  console.log(`当前页: `, val);
      this.currentPage = val;
      this.GetList();
    },
    onSubmit() {
      this.currentPage = 1;
      this.GetList();
    },
    copy(row) {
      //  console.log(row);
      var clickContent = row.coupon_code;
      var inputElement = document.getElementById("copy_content");
      inputElement.value = clickContent;
      inputElement.select();
      document.execCommand("Copy");
    },
  },
};
</script>
  
  <style>
.tabs {
  cursor: pointer;
  padding: 0.3rem;
  font-size: 1.5rem;
}
.tabs.active {
  color: #6d9fff;
  border-bottom: 1px solid #6d9fff;
}
</style>
  